import { createSlice } from '@reduxjs/toolkit';
import { DynamoConnector } from '../../DynamoConnector';
import { SORT_MAP } from './leaderboardSlice';
import { buildDefaultFilters } from '../../filterDefaults';

export const usersSlice = createSlice({
    name: 'users',
    initialState: {
        listItems: [],
        nextCursor: null,
        isFetching: false,
        loadingState: `idle`,
        filters: buildDefaultFilters('users'),
        sortBy: SORT_MAP.POWERLEVEL,
        sortDirection: SORT_MAP.DIRECTION.DESC,
        selectedListKey: null,
        selectedListIndex: -1,
    },
    reducers: {
        setUsersItems: (state, action) => {
            state.listItems = action.payload.map((item) => {
                return {
                    ...item,
                    key: item?.id,
                    storeKey: 'users',
                };
            });
        },
        setUsersNextCursor: (state, action) => {
            state.nextCursor = action.payload;
        },
        addNewUsersItems: (state, action) => {
            const { cursor, isReload } = action.payload;

            state.nextCursor = cursor || null;
            let i = -1;
            const newItems = action.payload.items.map((item) => {
                i += 1;

                return {
                    ...item,
                    key: item?.id,
                    storeKey: 'users',
                    indexPrefix: 'users_',
                    index: i + state?.listItems?.length || 0,
                };
            });

            if (!isReload) {
                state.listItems = state.listItems.concat(newItems);
            } else {
                state.listItems = newItems;
            }

            state.isFetching = false;
            state.loadingState = `idle`;
        },
        setUsersIsFetching: (state, action) => {
            state.isFetching = action.payload.isFetching;
            state.loadingState = action.payload.loadingState;
        },
        setUsersFilters: (state, action) => {
            state.filters = action.payload;
        },
        setUsersSortBy: (state, action) => {
            state.sortBy = action?.payload || SORT_MAP.POWERLEVEL;
        },
        setUsersSortDirection: (state, action) => {
            state.sortDirection = action?.payload || SORT_MAP.DIRECTION.DESC;
        },
        setSelectedListKey: (state, action) => {
            state.selectedListKey = action?.payload;
        },
        setSelectedListIndex: (state, action) => {
            state.selectedListIndex = action?.payload;
        },
    },
});

export const {
    setUsersItems,
    addNewUsersItems,
    setUsersIsFetching,
    setUsersFilters,
    setUsersSortBy,
    setUsersSortDirection,
    setSelectedListKey,
    setSelectedListIndex,
} = usersSlice.actions;

export const usersFetchFiltered = (filters, sortBy, sortDirection) => (dispatch) => {
    dispatch(setUsersFilters(filters));
    dispatch(fetchUsersItems(null, true, sortBy, sortDirection, filters));
};

export const fetchUsersItems =
    (cursor, isReload = false, sortBy, sortDirection, filters = {}) =>
    (dispatch) => {
        cursor = cursor !== -1 ? cursor : null;

        if (isReload) {
            dispatch(setUsersItems([]));
        }

        dispatch(
            setUsersIsFetching({
                isFetching: true,
                loadingState: cursor ? `loadingMore` : `loading`,
            })
        );

        DynamoConnector.getList(cursor, 'users', sortBy?.index || null, filters, sortDirection, (results) => {
            dispatch(
                addNewUsersItems({
                    items: results?.Items || [],
                    cursor: results?.LastEvaluatedKey ? results.LastEvaluatedKey : null,
                    type: null,
                    isReload,
                })
            );
        });
    };

export default usersSlice.reducer;
